import { render } from "./PackageofferCom.vue?vue&type=template&id=642f009c&scoped=true"
const script = {}

import "./PackageofferCom.vue?vue&type=style&index=0&id=642f009c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642f009c"]])

export default __exports__